export default {
  startDate: {
    required: false,
    validateOnBlur: false,
  },
  endDate: {
    required: false,
    validateOnBlur: false,
  },
  externalSystemsField: {
    required: false,
    validateOnBlur: false,
  },
  recentVisitIndexField: {
    required: false,
    validateOnBlur: false,
  },
};
